import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Providers from '@/lib/providers'
import './index.css'

// Pages
import LandingPage from '@/pages/LandingPage'
import LoginPage from '@/pages/LoginPage'
import SignupPage from '@/pages/SignupPage'
import AuthCallback from '@/pages/AuthCallback'
import Dashboard from '@/pages/Dashboard'
import OnboardingPage from '@/pages/OnboardingPage'
import DocumentsPage from '@/pages/DocumentsPage'
import TransactionsPage from '@/pages/TransactionsPage'
import GeneralJournalPage from '@/pages/GeneralJournalPage'
import ChartOfAccountsPage from '@/pages/ChartOfAccountsPage'
import CoaReviewPage from '@/pages/CoaReviewPage'
import ChatPage from '@/pages/ChatPage'
import ChatSessionPage from '@/pages/ChatSessionPage'
import BalanceSheetPage from '@/pages/reports/BalanceSheetPage'
import ProfitAndLossPage from '@/pages/reports/ProfitAndLossPage'

function App() {
  return (
    <Providers>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/general-journal" element={<GeneralJournalPage />} />
          <Route path="/chart-of-accounts" element={<ChartOfAccountsPage />} />
          <Route path="/coa-review" element={<CoaReviewPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/:sessionId" element={<ChatSessionPage />} />
          <Route path="/reports/balance-sheet" element={<BalanceSheetPage />} />
          <Route path="/reports/profit-and-loss" element={<ProfitAndLossPage />} />
        </Routes>
      </BrowserRouter>
    </Providers>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
